export default __webpack_public_path__ + "static/media/vlht_logo.035496fd.png";